// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #f6f9ff;
}

* {
  margin: 0;
  padding: 0;
  font-family: "inter";
}

.user_input {
  border: 1px solid rgb(184, 184, 184);
  border-radius: 5px;
  outline: none;
  width: 500px;
  padding: 2px 10px;
}

.customModal {
  max-width: 90%;
  width: 90%;
  height: 800px;
  border-radius: 5px;
}

.dropzone {
  width: 300px;
  height: 250px;
  border: 1px dashed #999;
  border-radius: 3px;
  text-align: center;
}

.upload-icon {
  margin-top: 50px;
  width: 100px;
  height: 80px;
}

.upload-input {
  position: relative;
  top: -150px;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.h {
  height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AACA;EACC,SAAA;EACA,UAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;EACA,yBAAA;AADD;;AAIA;EACC,SAAA;EACA,UAAA;EACA,oBAAA;AADD;;AAIA;EACC,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AADD;;AAKA;EACC,cAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;AAFD;;AAMA;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAHD;;AAMA;EACC,gBAAA;EACA,YAAA;EACA,YAAA;AAHD;;AAMA;EACC,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAHD;;AAMA;EACC,aAAA;AAHD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap\");\nbody {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n\t\t\"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n\t\tsans-serif;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tbackground-color: #f6f9ff;\n}\n\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tfont-family: \"inter\";\n}\n\n.user_input {\n\tborder: 1px solid rgb(184, 184, 184);\n\tborder-radius: 5px;\n\toutline: none;\n\twidth: 500px;\n\tpadding: 2px 10px;\n}\n\n\n.customModal{\n\tmax-width: 90%;\n\twidth: 90%;\n\theight: 800px; \n\tborder-radius: 5px;\n}\n\n\n.dropzone {\n\twidth: 300px;\n\theight: 250px;\n\tborder: 1px dashed #999;\n\tborder-radius: 3px;\n\ttext-align: center;\n}\n\n.upload-icon {\n\tmargin-top : 50px;\n\twidth: 100px;\n\theight: 80px;\n}\n\n.upload-input {\n\tposition: relative;\n\ttop: -150px;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\topacity: 0;\n}\n\n.h {\n\theight: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
